import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import {
    RecommendationCharacter,
    RecommendationType
} from '../../../typings/recommendations';
import { Image2 } from '../../Image2/Image2';
import { Shape2Icon } from '../../Shape2/Shape2';
import {
    RecommendationCard,
    RecommendationCardView
} from '../RecommendationCard';

import './AddBannerDisplayHrefsRecommendationCard.css';
import * as keyset from './AddBannerDisplayHrefsRecommendationCard.i18n';
import * as bannerDisplayHrefsExample1x from './BannerDisplayHrefsExample@1x.jpg';
import * as bannerDisplayHrefsExample2x from './BannerDisplayHrefsExample@2x.jpg';
import * as bannerDisplayHrefsExample3x from './BannerDisplayHrefsExample@3x.jpg';

const i18n = i18nFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    bannersNumber: number;
    bannersPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type AddBannerDisplayHrefsRecommendationCardProps =
    | RecommendationsPopupViewProps
    | NormalViewProps;

export class AddBannerDisplayHrefsRecommendationCard extends React.Component<
    AddBannerDisplayHrefsRecommendationCardProps
> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.addBannerDisplayHrefs}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                view={view}
                isInProgress={false}
                buttons={this.getButtons()}
                onShow={onShow}
            >
                {this.getBody()}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title-hint');
        }

        return i18n('normal-view-title-hint');
    };

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title');
        }

        return i18n('normal-view-title');
    };

    private getBody = () => {
        return (
            <>
                <div
                    className={Bem.cls(
                        'add-banner-display-href-recommendation-card',
                        'example-wrapper'
                    )}
                >
                    <Image2
                        src={{
                            src: bannerDisplayHrefsExample1x,
                            src2x: bannerDisplayHrefsExample2x,
                            src3x: bannerDisplayHrefsExample3x
                        }}
                        cls={Bem.cls(
                            'add-banner-display-href-recommendation-card',
                            'example'
                        )}
                    />
                </div>

                <p
                    className={Bem.cls(
                        'add-banner-display-href-recommendation-card',
                        'body-text'
                    )}
                >
                    {i18n('display-href-description')}
                </p>
            </>
        );
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { bannersNumber, bannersPageUrl } = this.props;
        const formattedItemsLength = formatNumber(bannersNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-banner-button', {
                    count: formattedItemsLength
                })
            ],
            bannersNumber
        );

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                text={buttonText}
                type={'link'}
                url={bannersPageUrl}
            />
        ];
    };
}
